import { Skeleton, Stack, SxProps, Typography } from "@mui/material";
import { IssueDto } from "../../http";
import { Proposal } from "./Proposal";

interface IProps {
  issue: IssueDto;
  isLoading?: boolean;
  focusedProposalGuid?: string;
  sx?: SxProps;
}

const Proposals = (props: IProps) => {
  return (
    <Stack spacing={0.5} sx={{ width: "100%", ...props.sx }}>
      {props.isLoading || props.issue == null ? (
        <Stack>
          {[...Array(3)].map((_, i) => (
            <Skeleton key={i} />
          ))}
        </Stack>
      ) : props.issue.proposals.length === 0 ? (
        <Typography variant="placeholder">No proposals yet.</Typography>
      ) : (
        props.issue.proposals.map((proposal) => (
          <Proposal
            key={proposal.guid}
            issue={props.issue}
            proposal={proposal}
            isFocused={proposal.guid === props.focusedProposalGuid}
          />
        ))
      )}
    </Stack>
  );
};

export { Proposals };
